import React from 'react';

const statusClassMap = {
  active: 'status-green',
  inactive: 'status-red',
};

// Status label mapping for proper display - WordPress style: only Active/Inactive
const statusLabelMap = {
  active: 'Active',
  inactive: 'Inactive',
};

const roleOptions = [
  { value: 'admin', label: 'Admin' },
  { value: 'manager', label: 'Manager' },
  { value: 'technician', label: 'Developer' },
  { value: 'user', label: 'Viewer' },
];

const roleLabelMap = {
  admin: 'Admin',
  manager: 'Manager',
  technician: 'Developer',
  user: 'Viewer',
};

const renderSortIcon = (column, sortBy, sortOrder) => {
  if (sortBy !== column) return null;
  return <span className="sort-icon">{sortOrder === 'asc' ? '↑' : '↓'}</span>;
};

const UserTable = ({
  users,
  loading,
  sortBy,
  sortOrder,
  onSort,
  canEditRole,
  onRoleChange,
  currentUserRole,
  showActions,
}) => {
  const columnCount = showActions ? 8 : 7;

  return (
    <table className="users-table">
      <thead>
        <tr>
          <th onClick={() => onSort('fullName')} className="sortable">
            Full Name
            {renderSortIcon('fullName', sortBy, sortOrder)}
          </th>
          <th onClick={() => onSort('email')} className="sortable">
            Email
            {renderSortIcon('email', sortBy, sortOrder)}
          </th>
          <th onClick={() => onSort('username')} className="sortable">
            Username
            {renderSortIcon('username', sortBy, sortOrder)}
          </th>
          <th onClick={() => onSort('status')} className="sortable">
            Status
            {renderSortIcon('status', sortBy, sortOrder)}
          </th>
          <th onClick={() => onSort('role')} className="sortable">
            Role
            {renderSortIcon('role', sortBy, sortOrder)}
          </th>
          <th onClick={() => onSort('joinedDate')} className="sortable">
            Joined Date
            {renderSortIcon('joinedDate', sortBy, sortOrder)}
          </th>
          <th>Last Active</th>
          {showActions && <th>Actions</th>}
        </tr>
      </thead>
      <tbody>
        {loading ? (
          <tr>
            <td colSpan={columnCount} className="loading-cell">
              <div className="loading-spinner">Loading users...</div>
            </td>
          </tr>
        ) : users.length === 0 ? (
          <tr>
            <td colSpan={columnCount} className="empty-cell">
              No users found
            </td>
          </tr>
        ) : (
          users.map((user) => (
            <tr key={user.id}>
              <td title={user.fullName || ''}>
                <div className="user-name-cell">
                  <div className="user-avatar">
                    {user.fullName
                      ?.split(' ')
                      .filter(Boolean)
                      .map((part) => part[0])
                      .join('')
                      .slice(0, 2)
                      .toUpperCase()}
                  </div>
                  <span>{user.fullName}</span>
                </div>
              </td>
              <td title={user.email || ''}>{user.email}</td>
              <td title={user.username || ''}>{user.username}</td>
              <td>
                <span className={`status-badge ${statusClassMap[user.status?.toLowerCase()] || 'status-red'}`}>
                  {statusLabelMap[user.status?.toLowerCase()] || 'Inactive'}
                </span>
              </td>
              <td title={roleLabelMap[user.role] || user.role || ''}>{roleLabelMap[user.role] || user.role}</td>
              <td title={user.joinedDateLabel || ''}>{user.joinedDateLabel}</td>
              <td title={user.lastActiveLabel || ''}>{user.lastActiveLabel}</td>
              {showActions && (
                <td>
                  {canEditRole ? (
                    <select
                      className="role-select"
                      value={user.role}
                      onChange={(e) => onRoleChange(user.id, e.target.value)}
                    >
                      {roleOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <span className="no-actions">
                      {currentUserRole === 'manager' || currentUserRole === 'technician' ? 'No access' : '—'}
                    </span>
                  )}
                </td>
              )}
            </tr>
          ))
        )}
      </tbody>
    </table>
  );
};

export default UserTable;


